
<table mat-table [dataSource]="enrolled" matSort multiTemplateDataRows >
  <ng-container matColumnDef="program">
    <mat-header-cell *matHeaderCellDef  mat-sort-header> Program </mat-header-cell>
    <mat-cell *matCellDef="let el; let i = dataIndex">
      <mat-select matNativeControl (selectionChange)="onSelected($event, el)" [(value)]="el.name">
        <mat-option value=""></mat-option>
        @for (nns of tracks; track nns) {
          <mat-option [value]="nns.name">
            {{ nns.name }}
          </mat-option>
        }
      </mat-select>

    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef  mat-sort-header> Name </mat-header-cell>
    <mat-cell *matCellDef="let el"> {{el.name}}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="registered">
    <mat-header-cell *matHeaderCellDef  mat-sort-header> Registered </mat-header-cell>
    <mat-cell *matCellDef="let el"> {{    dateFormating(el.date_registered, "ts")}}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="purchased">
    <mat-header-cell *matHeaderCellDef  mat-sort-header> Purchased </mat-header-cell>
    <mat-cell *matCellDef="let el"> {{    dateFormating(el.date_purchased, "ts")}}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="hours">
    <mat-header-cell *matHeaderCellDef  mat-sort-header> Hours </mat-header-cell>
    <mat-cell *matCellDef="let el"> {{el.hours_taken}}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="certificate">
    <mat-header-cell *matHeaderCellDef  mat-sort-header> Create/Link to Certificate </mat-header-cell>
    <mat-cell *matCellDef="let el">
      @if (allCompleted(el)) {
        <span>
          @if (el.certificate_url=='') {
            <span> <button mat-stroked-button (click)="oncreateCert(el)"  >Create<mat-icon>approval</mat-icon></button> </span>
          } @else {
            <a href="{{ el.certificate_url }}" target="_blank">View</a>
          }
        </span>
      } @else {
        Not all courses completed
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="expandedDetail">
    <mat-cell *matCellDef="let el" [attr.colspan]="courseColumns.length">
      @if (el.track && el.track.courses) {
        <span>
          <table>
            @for (column of headers; track column) {
              <th>
                {{column}}
              </th>
            }
            @for (row of el.track.courses; track row; let j = $index) {
              <tr>
                <td >{{ row.title.rendered }}</td>
                <td >@if (row.date_registered=='') {
                  <span><mat-checkbox (change)="clickRegister( el,row)" [checked]="false"></mat-checkbox></span>
                } @else {
                  {{ dateFormating(row.date_registered, "ts" )}}
                }
              </td>
              <td > @if (row.date_completed=='') {
                <span><mat-checkbox (change)="clickComplete(el,row)" [checked]="false"></mat-checkbox></span>
              } @else {
                {{  dateFormating(row.date_completed, "ts")}}
              }
            </td>
          </tr>
        }
      </table>
    </span>
  }
</mat-cell>
</ng-container>
<mat-header-row *matHeaderRowDef="courseColumns"></mat-header-row>
<mat-row *matRowDef="let row; columns: courseColumns;"></mat-row>
<mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></mat-row>>
</table>